import { Fragment, useEffect } from "react";

import Consulta from "./Consulta";
import ControlesCallCenter from "./ControlesCallCenter";
import DirectorioMedico from "./DirectorioMedico";
import FormBuscarFolio from "./FormBuscarFolio";
import { Grid } from "@material-ui/core";
import HelperConsulta from "./HelperConsulta";
import HelperInicio from "./HelperInicio";
import HelperOcupado from "./HelperOcupado";
import InformacionBotones from "./InformacionBotones";
import MeditocBody from "../../../utils/MeditocBody";
import MeditocHeader from "../../../utils/MeditocHeader";
import MeditocSwitch from "../../../utils/MeditocSwitch";
import Preview from "../../../../zoom/feature/preview/preview";
import ZoomMainApp from "../../../../zoom/ZoomMainApp";
import { useCallCenter } from "../../../../context/CallCenterContext";
import { useLogin } from "../../../../context/LoginContext";
import { useZoomMeditoc } from "../../../../context/ZoomMeditocContext";

export default function CallCenter() {
    const {
        consultaIniciada,
        entCallCenter,
        usuarioColaborador,
        salaIceLink,
        colaboradorDisponible,
        intervalColaboradorEstatus,
        handleToggleEstatusColaborador,
        handleClickStartCallCenter,
    } = useCallCenter();
    const { meetingArgs, handleChangeMeetingArgs } = useZoomMeditoc();
    const { usuarioPermisos } = useLogin();

    const permisos = usuarioPermisos["4"].Submodulos["1"];

    useEffect(() => {
        return () => {
            window.clearInterval(intervalColaboradorEstatus);
        };
        // eslint-disable-next-line
    }, [intervalColaboradorEstatus]);

    useEffect(() => {
        handleClickStartCallCenter();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <MeditocHeader title={<ControlesCallCenter />}>
                {permisos.Botones["1"] && ( //Estatus
                    <Fragment>
                        <span className="rob-con bold size-20">
                            Estatus: {colaboradorDisponible ? "DISPONIBLE" : "OCUPADO"}
                        </span>
                        <MeditocSwitch
                            checked={colaboradorDisponible}
                            onChange={handleToggleEstatusColaborador}
                            disabled={!usuarioColaborador}
                        />
                    </Fragment>
                )}
            </MeditocHeader>
            {usuarioColaborador && (
                <Fragment>
                    <HelperInicio />
                    <HelperOcupado />
                    <HelperConsulta />
                    <MeditocBody>
                        <Grid container spacing={3}>
                            <Grid item md={6} sm={12} xs={12}>
                                {meetingArgs ? <ZoomMainApp meetingArgs={meetingArgs} /> : <Preview></Preview>}
                                {/* {salaIceLink} */}
                            </Grid>
                            {consultaIniciada && entCallCenter && (
                                <Grid item md={6} sm={12} xs={12}>
                                    <Consulta />
                                </Grid>
                            )}
                        </Grid>
                    </MeditocBody>
                    <InformacionBotones />
                    <FormBuscarFolio />
                </Fragment>
            )}
            <DirectorioMedico />
        </Fragment>
    );
}
